/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { metaMcpList } from "../funcs/metaMcpList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMetaMcpServersResult } from "../models/components/listmetamcpserversresult.js";
import {
  ListMetaMcpServersRequest,
  ListMetaMcpServersSecurity,
} from "../models/operations/listmetamcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type MetaMcpServersQueryData = ListMetaMcpServersResult;

export function prefetchMetaMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMetaMcpServersRequest | undefined,
  security?: ListMetaMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMetaMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMetaMcpServersQuery(
  client$: GramCore,
  request?: ListMetaMcpServersRequest | undefined,
  security?: ListMetaMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<MetaMcpServersQueryData>;
} {
  return {
    queryKey: queryKeyMetaMcpServers({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function metaMcpServersQueryFn(
      ctx,
    ): Promise<MetaMcpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(metaMcpList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMetaMcpServers(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "metaMcp", "list", parameters];
}
